export default __webpack_public_path__ + "static/media/mass-payout.81704905.svg";